import React, {useContext} from 'react'
import {FaqContext} from "../context";


const BlockHelpContainer = (props) => {
    const {renderHelpComponent, changeHelpRenderState, faqList} = useContext(FaqContext);

    //why return liste when only 1 item or can faqList have multiple items with same slug?
    const getDataList = () => {
        const results = [];
        faqList.forEach((d, i) => {
            if (d.slug === props.slug) {
                results.push(<div>{d.title}<div dangerouslySetInnerHTML={{__html: d.body}}/></div>)
            }

        })
        return results;
        /*
        return (faqList.entries.map(d => {
                if (d.slug === props.slug) {
                    return <div>
                        {d.title}
                        <div dangerouslySetInnerHTML={{__html: d.body}}/>
                    </div>
                }
            }
        ))*/
    };
    if (props.slug === renderHelpComponent) {
        return (

            <div className={'BlockHelpContainer'}>
                <div className={'BlockHelpContainer-header'}>
                    <h4>{props.slug} Hjelp</h4>
                    <span className={'BlockHelpContainer-close'}
                          onClick={(e) => {
                              e.preventDefault();
                              changeHelpRenderState('');
                          }}>
                    &times;
                </span>
                </div>
                {!faqList? <div>
                        Loading ..
                    </div>:
                    <div className={'block-help-component'}>
                        {faqList && getDataList()}
                    </div>}
            </div>
        )
    } else return null

};


export default BlockHelpContainer;